import React, { Component } from 'react'
import './KeyFocusArea.css'
import { Module } from 'module'

let icons = {
    "road": <i className="fa fa-road"></i>,
    "Road": <i className="fa fa-road"></i>,
    "rail": <i className="fa fa-train"></i>,
    "Rail": <i className="fa fa-train"></i>,
    "ocean": <i className="fa fa-ship"></i>,
    "Ocean": <i className="fa fa-ship"></i>,
    "air": <i className="fa fa-plane"></i>,
    "Air": <i className="fa fa-plane"></i>,
}
let icon_name = ''
let modeOfOperations = []
let modeOfTransportation = []
let businessDomain = []
export class KeyFocusArea extends Component {

    componentWillReceiveProps(incomingData) {
        modeOfOperations = incomingData.transporter_data.modes_of_operation
        modeOfTransportation = incomingData.transporter_data.modes_of_transportation
        businessDomain = incomingData.transporter_data.domain_business
    }

    /* modeOfTransportatioData() {
        var i
        for (i = 0; i < modeOfOperations.length; i++) {
        }
    } */

    render() {
        
        return (
            <div>
                <span className="data_header">Key Focus Area</span>
                <div className="row">
                    <div className="col-md-6 modes">
                        <b className="text-center modeHeder">Mode of Transportation</b>
                        {
                            (modeOfTransportation === null || modeOfTransportation === undefined || modeOfTransportation.length === 0) ? (
                                <div className="row">
                                    <div className="col-12">
                                        Details not available
                                    </div>
                                </div>
                            ) : (
                                modeOfTransportation.map((mode,i) => <p key={i}>
                                    <b className="mode_name"> {icons[mode.name]}   {mode.name} </b><br />
                                    {
                                       (mode.values==undefined || mode.values==null||mode.values=='')?(''):( mode.values.map((value,index) => <><div key={index}>
                                              - <span className="mode_percentage"> {value} </span><br />
                                        </div></>))
                                    }
                                </p>)
                            )
                        }
                    </div>
                    <div className="col-md-6 modes">
                        <b className="text-center modeHeder">Mode of Operations</b>
                        {
                            (modeOfOperations === undefined || modeOfOperations === null || modeOfOperations.length === 0) ? (
                                <div className="row">
                                    <div className="col-12">
                                        Details not available
                                    </div>
                                </div>
                            ) : (
                                    modeOfOperations.map((mode,index2) => <p key={index2}>
                                        -  <b className="mode_name"> {mode.name} </b> : <span className="mode_percentage"> {(mode.percentage==null||mode.percentage==undefined||mode.percentage=='')?('-'):(`${mode.percentage}%`)} </span>
                                    </p>)
                                )
                        }
                    </div>
                </div>
                <div className='col-md'>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                    <b className="text-center modeHeder">Business Domain</b>
                    {businessDomain === undefined || businessDomain === null || businessDomain.length === 0 ? (<div className="row">
                                    <div className="col-12">
                                        Details not available
                                    </div>
                                </div>):(
                                    businessDomain.map((domain, index) => <div>{domain}</div>)
                                )}
                    </div>
                </div>
            </div>
        )
    }
}

export default KeyFocusArea
